import { useEffect } from 'react';

// Sets --app-height to the viewport minus the on-screen keyboard so full-height shells shrink
// instead of being overlaid. iOS Safari reports the keyboard via visualViewport; the kiosk
// WKWebView can't, so it feeds --keyboard-height + a 'myriad:keyboard-height' event (see
// myriad-kiosk-ios ContentView.swift). We use whichever signal is present.
const KEYBOARD_HEIGHT_EVENT = 'myriad:keyboard-height';

const useViewportHeight = () => {
  useEffect(() => {
    const vv = typeof window !== 'undefined' ? window.visualViewport : null;

    const nativeKeyboardInset = () => {
      const px = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--keyboard-height')
      );
      return Number.isFinite(px) && px > 0 ? px : 0;
    };

    const sync = () => {
      const viewportInset = vv ? Math.max(0, window.innerHeight - vv.height) : 0;
      const keyboard = Math.max(nativeKeyboardInset(), viewportInset);
      const height = window.innerHeight - keyboard;
      document.documentElement.style.setProperty('--app-height', `${height}px`);
      document.documentElement.style.setProperty('--keyboard-inset', `${keyboard}px`);
    };

    sync();

    if (vv) {
      vv.addEventListener('resize', sync);
      vv.addEventListener('scroll', sync);
    }
    window.addEventListener('resize', sync);
    window.addEventListener('orientationchange', sync);
    window.addEventListener(KEYBOARD_HEIGHT_EVENT, sync);

    return () => {
      if (vv) {
        vv.removeEventListener('resize', sync);
        vv.removeEventListener('scroll', sync);
      }
      window.removeEventListener('resize', sync);
      window.removeEventListener('orientationchange', sync);
      window.removeEventListener(KEYBOARD_HEIGHT_EVENT, sync);
    };
  }, []);
};

export default useViewportHeight;
